import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import { lazy } from "react";

const AdminLayout = lazy(() => import("../pages/admin/components/AdminLayout"));
const AdminLogin = lazy(() => import("../pages/admin/login/page"));
const AdminDashboard = lazy(() => import("../pages/admin/dashboard/page"));
const AdminPosts = lazy(() => import("../pages/admin/posts/page"));
const AdminPostEdit = lazy(() => import("../pages/admin/posts/edit/page"));
const AdminPortfolio = lazy(() => import("../pages/admin/portfolio/page"));
const AdminPortfolioEdit = lazy(() => import("../pages/admin/portfolio/edit/page"));
const AdminMedia = lazy(() => import("../pages/admin/media/page"));
const AdminWordPress = lazy(() => import("../pages/admin/wordpress/page"));
const AdminProfile = lazy(() => import("../pages/admin/profile/page"));
const AdminContacts = lazy(() => import("../pages/admin/contacts/page"));
const AdminSettings = lazy(() => import("../pages/admin/settings/page"));
const ResponsiveDesign = lazy(() => import("../pages/responsive-design/page"));
const NewsArchive = lazy(() => import("../pages/news/archive/page"));
const NewsDetail = lazy(() => import("../pages/news/detail/page"));
const PortfolioArchive = lazy(() => import("../pages/portfolio/archive/page"));
const PortfolioDetail = lazy(() => import("../pages/portfolio/detail/page"));
const EventVideoOperation = lazy(() => import("../pages/services/event-video-operation/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/responsive-design",
    Component: ResponsiveDesign,
  },
  {
    path: "/services/event-video-operation",
    Component: EventVideoOperation,
  },
  {
    path: "/news",
    Component: NewsArchive,
  },
  {
    path: "/news/:id",
    Component: NewsDetail,
  },
  {
    path: "/portfolio",
    Component: PortfolioArchive,
  },
  {
    path: "/portfolio/:id",
    Component: PortfolioDetail,
  },
  {
    path: "/admin/login",
    Component: AdminLogin,
  },
  {
    path: "/admin",
    Component: AdminLayout,
    children: [
      {
        path: "dashboard",
        Component: AdminDashboard,
      },
      {
        path: "posts",
        Component: AdminPosts,
      },
      {
        path: "posts/new",
        Component: AdminPostEdit,
      },
      {
        path: "posts/edit/:id",
        Component: AdminPostEdit,
      },
      {
        path: "portfolio",
        Component: AdminPortfolio,
      },
      {
        path: "portfolio/new",
        Component: AdminPortfolioEdit,
      },
      {
        path: "portfolio/edit/:id",
        Component: AdminPortfolioEdit,
      },
      {
        path: "contacts",
        Component: AdminContacts,
      },
      {
        path: "media",
        Component: AdminMedia,
      },
      {
        path: "wordpress",
        Component: AdminWordPress,
      },
      {
        path: "settings",
        Component: AdminSettings,
      },
      {
        path: "profile",
        Component: AdminProfile,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
